import Vue from 'vue';
import VueRouter from 'vue-router';

// 导入组件
import Home from '../views/Home.vue';
import About from '../views/About.vue';
import Products from '../views/Products.vue';
import Partner from '../views/Partner.vue';
import Contact from '../views/Contact.vue';
import Services from '../views/Services.vue';
import CarrierNetwork from '../views/CarrierNetwork.vue';
import GovernmentEnterprise from '../views/GovernmentEnterprise.vue';
import ConsumerTerminal from '../views/ConsumerTerminal.vue';
import FiveGTechnology from '../views/5GTechnology.vue';
import CloudBigData from '../views/CloudBigData.vue';

Vue.use(VueRouter);

const routes = [
  {
    // 首页
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    // 关于云
    path: '/about',
    name: 'About',
    component: About
  },
  {
    // 产品查询
    path: '/products',
    name: 'Products',
    component: Products
  },
  {
    // 合作与客户案例
    path: '/partner',
    name: 'Partner',
    component: Partner
  },
  {
    // 服务与解决方案
    path: '/services',
    name: 'Services',
    component: Services
  },
  {
    // 联系我们
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    // 运营商网络
    path: '/carrier-network',
    name: 'CarrierNetwork',
    component: CarrierNetwork
  },
  {
    // 政企解决方案
    path: '/government-enterprise',
    name: 'GovernmentEnterprise',
    component: GovernmentEnterprise
  },
  {
    // 消费者终端
    path: '/consumer-terminal',
    name: 'ConsumerTerminal',
    component: ConsumerTerminal
  },
  {
    // 5G技术
    path: '/5g-technology',
    name: '5GTechnology',
    component: FiveGTechnology
  },
  {
    // 云计算与大数据
    path: '/cloud-big-data',
    name: 'CloudBigData',
    component: CloudBigData
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // 路由切换时自动滚动到顶部
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置，则恢复位置，否则滚动到顶部
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

// 也可以使用导航守卫实现
router.beforeEach((to, from, next) => {
  // 在路由切换前将页面滚动到顶部
  window.scrollTo(0, 0);
  next();
});

export default router;
